// Central config for third-party integrations.
//
// Mapillary access token (a "client token", starts with "MLY|").
// Get one free — see MAPILLARY_SETUP.md in the project root for step-by-step
// instructions. Put your real token in a .env file at the project root:
//
//   REACT_APP_MAPILLARY_TOKEN=MLY|xxxxxxxx|yyyyyyyy
//
// Create React App only exposes env vars that start with REACT_APP_ and reads
// them at build/start time, so restart `npm start` after editing .env.
const PLACEHOLDER = "PASTE_YOUR_MAPILLARY_TOKEN_HERE";

export const MAPILLARY_TOKEN =
  process.env.REACT_APP_MAPILLARY_TOKEN || PLACEHOLDER;

// True only when a real token has been supplied. The UI uses this to decide
// whether to attempt to load imagery or show a "not configured" note.
export const MAPILLARY_ENABLED =
  Boolean(MAPILLARY_TOKEN) && MAPILLARY_TOKEN !== PLACEHOLDER;
